/*
 * Copyright Western Australian Land Information Authority 2023
 */

import {Injectable} from '@angular/core';
import {ModalService} from '../modal-service.service';
import {NewInterestsNotificationModalComponent} from './new-interest-notification-modal.component';

export interface NewInterestNotificationModalProps {
    interest: object;
}

@Injectable({
    providedIn: 'root'
})
export class NewInterestNotificationModalService extends ModalService {
    showModal(props: NewInterestNotificationModalProps) {
        this.createModalComponent(NewInterestsNotificationModalComponent);
        const newInterestsNotificationModalComponent = this.modalComponentRef.instance as NewInterestsNotificationModalComponent;
        newInterestsNotificationModalComponent.interest = props.interest;
        console.log('show NewInterestsNotificationModalComponent');
        this.showModalComponent();
        return newInterestsNotificationModalComponent.modalClosed;
    }
}
